import axios from "axios";

const PAYMENT_SERVICE_BASE = `${process.env.REACT_APP_API_URL}/paymentService/api/payments`;

const apiClient = axios.create({
  baseURL: PAYMENT_SERVICE_BASE,
  withCredentials: true,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
const paymentApi = {
  generateQRCode: (payload) => {
    return apiClient.post("/generate-qr", payload);
  },
  confirmPayment: (transactionId) => {
    return apiClient.put(`/confirm/${transactionId}`);
  },
  getPendingPaymentStatus: () => {
    return apiClient.get("/getPendingTransactions");
  },

  approveTransaction: (transactionId) => {
    return apiClient.put(`/approve/${transactionId}`);
  },
  rejectTransaction: (transactionId) => {
    return apiClient.put(`/reject/${transactionId}`);
  },

  getApprovedPaymentStatus: () => {
    return apiClient.get("/getApprovedTransactions");
  },
  getRejectedPaymentStatus: () => {
    return apiClient.get("/getRejectedTransactions");
  },

  getUserTransactionHistory: (
    userId,
    page,
    pageSize,
    sortedColumn,
    sortOrder,
  ) => {
    return apiClient.get("/getTransactionsByUser", {
      params: { userId, page, pageSize, sortedColumn, sortOrder },
    });
  },
 getTransactionsByCompany: (
    userId,
    companyName,
    page,
    pageSize,
    sortedColumn,
    sortOrder,
  ) => {
    return apiClient.get("/getTransactionsByCompany", {
      params: { userId, companyName, page, pageSize, sortedColumn, sortOrder },
    });
  },

};
export default paymentApi;
